import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/veteran-facing-services-tools/veteran-facing-services-tools/packages/documentation/src/layouts/SidebarLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "how-templates-work-for-markdown-pages"
    }}>{`How templates work for Markdown pages`}</h1>
    <div className="deprecation-message">
    <h2>We're moving our docs!</h2>
    <h3>Find <a href="https://depo-platform-documentation.scrollhelp.site/developer-docs/How-templates-work.1854832706.html">the latest version of this page</a> on the Platform website.</h3>
    <h3>Still can't find what you're looking for? Reach out to <a href="https://dsva.slack.com/archives/CBU0KDSB1">#vfs-platform-support</a> on Slack.</h3>
    </div>
    <p>{`Templates use `}<a parentName="p" {...{
        "href": "https://github.com/leizongmin/tinyliquid/"
      }}>{`tinyliquid`}</a>{`, a JavaScript implementation of `}<a parentName="p" {...{
        "href": "https://shopify.github.io/liquid/"
      }}>{`Liquid`}</a>{`.`}</p>
    <p>{`There are three "wrapper" templates currently in use for Markdown content. They're all in `}<inlineCode parentName="p">{`src/site/layouts`}</inlineCode>{`.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`page-react`}</inlineCode>{`: Houses our React pages.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`page-react-sidebar`}</inlineCode>{`: Houses our React pages that have a sidebar.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`page-breadcrumbs`}</inlineCode>{`: Houses our non-React content pages.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`page-playbook`}</inlineCode>{`: Houses Playbook pages.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`home`}</inlineCode>{`: Template for the home page`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`home`}</inlineCode>{`: Template for the home page without search`}</li>
    </ul>
    <p><inlineCode parentName="p">{`page-breadcrumbs`}</inlineCode>{` is a container template that loads layouts for the content between the header and the footer. Those are in `}<inlineCode parentName="p">{`content/layouts/includes/`}</inlineCode>{`.`}</p>
    <p>{`Templates are loaded based on the value of the `}<inlineCode parentName="p">{`template`}</inlineCode>{` property in the `}<a parentName="p" {...{
        "href": "http://yaml.org/"
      }}>{`YAML`}</a>{`/front-page data of each content file -- the text between the `}<inlineCode parentName="p">{`---`}</inlineCode>{`. Content files can be found in `}<inlineCode parentName="p">{`content/pages/`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "adding-a-new-template"
    }}>{`Adding a new template`}</h2>
    <ul>
      <li parentName="ul">{`Add a new HTML + Liquid template file to `}<inlineCode parentName="li">{`src/site/includes`}</inlineCode></li>
      <li parentName="ul">{`Update `}<inlineCode parentName="li">{`page-breadcrumbs`}</inlineCode>{` with a new case for the new layout.`}</li>
      <li parentName="ul">{`Update the `}<inlineCode parentName="li">{`template`}</inlineCode>{` YAML property for whichever pages should load the new template.`}</li>
    </ul>
    <h2 {...{
      "id": "content-meta-data"
    }}>{`Content meta data`}</h2>
    <p>{`To date, we've used `}<a parentName="p" {...{
        "href": "http://yaml.org/"
      }}>{`YAML`}</a>{` syntax in Markdown files as a way to structure data such as related links (majorlinks) and navigation cards.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      